import Vue from "vue";
import { Button, Form, FormItem, Input, Message, Container, Aside, Header, Main, Menu, Footer, Submenu, MenuItem, Breadcrumb, BreadcrumbItem, Dropdown, DropdownItem, DropdownMenu, Select, Option, Table, TableColumn, Switch, Pagination, Dialog, RadioGroup, Radio, DatePicker, Empty, Tag, Carousel, CarouselItem, Upload, MessageBox, Tooltip, Row, Col, Loading, Popover, Tabs, TabPane, Checkbox, CheckboxGroup, Image, Drawer } from "element-ui"
Vue.use(Button)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(Container)
Vue.use(Aside)
Vue.use(Header)
Vue.use(Main)
Vue.use(Footer)
Vue.use(Menu)
Vue.use(Submenu)
Vue.use(MenuItem)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(Dropdown)
Vue.use(DropdownItem)
Vue.use(DropdownMenu)
Vue.use(Select)
Vue.use(Option)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Switch)
Vue.use(Pagination)
Vue.use(Dialog)
Vue.use(RadioGroup)
Vue.use(Radio)
Vue.use(DatePicker)
Vue.use(Empty)
Vue.use(Tag)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Upload)
Vue.use(Tooltip)
Vue.use(Row)
Vue.use(Col)
Vue.use(Loading)
Vue.use(Popover)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(CheckboxGroup)
Vue.use(Checkbox)
Vue.use(Image)
Vue.use(Drawer)






Vue.prototype.$message = Message
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$prompt = MessageBox.prompt





